import axiosTokenInstance from 'services/api/backoffice';
import { DETAIL_TRANSACTIONS_NETPAY, DETAIL_TRANSACTIONS_ERROR } from '_models/redux/types';

// Action function
export const detailNetPayAction = (transactions_id) => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(
      `api/reports/v2/transactions-details-netpay/${transactions_id}`,
    );

    const { data, status } = response || {};

    dispatch({
      type: DETAIL_TRANSACTIONS_NETPAY,
      response: data || {},
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: DETAIL_TRANSACTIONS_ERROR,
      response: e || {},
    });
  }
};
